<template>
  <footer class="flex-none" style="height: 20%">
    <div class="flex items-center justify-center h-full">
      <div class="w-1/2">
        <BaseImg src="/supporter-1.png" class="w-32 ml-auto sm:w-64" />
      </div>
      <div class="w-1/2">
        <BaseImg src="/supporter-2.png" class="w-32 mr-auto sm:w-64" />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'KioskFooter',
}
</script>
